<template>
  <el-card class="h-full" :body-style="{ padding: '20px', height: '100%' }">
    <div>
      <el-input
        v-model="search.jobName"
        clearable
        placeholder="任务名称"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        v-model="search.dataSourceName"
        clearable
        placeholder="数据源名称"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        v-model="search.tableName"
        clearable
        placeholder="数据表名称"
        class="w-200px mr-10px"
      ></el-input>
      <el-input
        v-model="search.destTableName"
        clearable
        placeholder="目标表名称"
        class="w-200px mr-10px"
      ></el-input>
      <el-select v-model="search.state" clearable placeholder="状态" class="w-200px mr-10px">
        <el-option label="成功" value="成功"></el-option>
        <el-option label="失败" value="失败"></el-option>
      </el-select>
      <el-date-picker
        v-model="time"
        type="datetimerange"
        range-separator="至"
        start-placeholder="创建开始日期"
        end-placeholder="创建结束日期"
        class="mr-10px"
      ></el-date-picker>
      <el-button type="primary" @click="searchTableData()">搜索</el-button>
      <el-button @click="reset">重置</el-button>
      <el-button type="danger" @click="deleteMetadata(idList)" :disabled="!$hasAccess('delete')"
        >删除</el-button
      >
    </div>
    <el-table
      :data="tableData"
      height="calc(100% - 107px)"
      class="mt-20px"
      border
      v-loading="tableLoading"
      :row-key="(record) => record.id"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column type="index" label="序号" width="55" align="center">
        <template slot-scope="scope">
          <span>{{ (page.pageNo - 1) * page.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="jobName" label="任务名称" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="dataSourceName"
        label="数据源名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="tableName" label="数据表名称" show-overflow-tooltip></el-table-column>
      <el-table-column
        prop="destTableName"
        label="目标表名称"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="collectNumber"
        label="采集数量"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column prop="executeTime" label="执行时间" show-overflow-tooltip></el-table-column>
      <el-table-column prop="timeConsuming" label="执行时长" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="state" label="状态" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-tag size="small" type="success" v-if="scope.row.state === '成功'">成功</el-tag>
          <el-tag size="small" type="success" v-else-if="scope.row.remark.includes('运行中')"
            >运行中</el-tag
          >
          <el-tag size="small" type="danger" v-else>失败</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="说明" show-overflow-tooltip></el-table-column>
      <el-table-column prop="createdTime" label="创建时间" show-overflow-tooltip></el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="{ row }">
          <el-button @click.stop="view(row)" size="mini">{{ $t('view') }}</el-button>
          <el-button
            :disabled="!$hasAccess('delete')"
            @click.stop="deleteMetadata([row.id])"
            size="mini"
            >{{ $t('delete') }}</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="tr">
      <el-pagination
        class="mt-20px float-right"
        background
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="page.pageNo"
        :page-sizes="$pageSizeAll"
        :page-size.sync="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
      ></el-pagination>
    </div>

    <!-- 查看 -->
    <el-dialog
      title="查看"
      :visible.sync="dialogVisible"
      width="50%"
      :close-on-click-modal="false"
      v-dialogDrag
    >
      <el-form :model="form" label-width="150px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="任务名称">
              <el-input v-model="form.jobName" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据源名称">
              <el-input v-model="form.dataSourceName" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="数据表名称">
              <el-input v-model="form.tableName" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="目标表名称">
              <el-input v-model="form.destTableName" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="采集数量">
              <el-input v-model="form.collectNumber" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行时间">
              <el-input v-model="form.executeTime" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="执行时长">
              <el-input v-model="form.timeConsuming" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态">
              <el-input v-model="form.state" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间">
              <el-input v-model="form.createdTime" disabled clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="说明">
              <el-input v-model="form.remark" type="textarea" disabled clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
  </el-card>
</template>

<script>
import StickerSourceManagementService from '@/services/StickerSourceManagementService'

export default {
  name: 'collectTaskRecords',
  data() {
    return {
      search: {
        jobName: '',
        dataSourceName: '',
        tableName: '',
        destTableName: '',
        state: '',
      },
      time: '',
      tableData: [],
      tableLoading: false,
      idList: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      dialogVisible: false,
      form: {},
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.idList = _.map(val, (item) => {
        return item.id
      })
    },
    sizeChange(size) {
      this.page.pageSize = size
      this.searchTableData()
    },
    currentChange(num) {
      this.page.pageNo = num
      this.searchTableData()
    },
    async searchTableData() {
      this.tableLoading = true
      const res = await StickerSourceManagementService.taskRunRecords({
        ...this.search,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        startTime: this.time ? this.time[0] : '',
        endTime: this.time ? this.time[1] : '',
      })
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    reset() {
      this.search = this.$options.data().search
      this.searchTableData()
    },
    deleteMetadata(ids) {
      if (ids.length) {
        this.$confirm('是否确定要删除记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }).then(async () => {
          const res = await StickerSourceManagementService.deleteTaskRunRecords(ids)
          if (res && res.code === 0) {
            this.$message.success('删除成功')
            this.searchTableData()
          }
        })
      } else {
        this.$message.info('请选择要删除的记录')
      }
    },
    view(row) {
      this.form = _.clone(row)
      this.dialogVisible = true
    },
  },
  created() {
    this.searchTableData()
  },
}
</script>
